import ApiService from "./api.service";
const Files = {
  upload: async function (construction_id, fileData) {
    let response = await ApiService.post("/construction/" + construction_id+'/files', fileData);
    return response.data;
  },
  get: async function(construction_id){
    let response = await ApiService.get("/construction/" + construction_id+'/files');
    return response.data.files;
  },
  delete: async function(construction_id, filesIds){
    await ApiService.patch("/construction/" + construction_id+'/files/delete', {
      filesids: filesIds
    });
    return true;
  }
};

export default Files;